import { Stack, type SxProps, type Theme, Typography } from '@mui/material'
import Image from 'next/image'
import { Nullish } from '@omnea-app/packages/universal/utility-types/utilityTypes'

interface OrganisationLogoProps {
  organisation: {
    name: string
    logoUrl: Nullish<string>
    isQa: boolean
  }
  logoSize?: { width: number; height: number }
  sx?: SxProps<Theme>
}

const DEFAULT_HEIGHT = 24
const DEFAULT_HEIGHT_PX = `${DEFAULT_HEIGHT}px`

const QaChip = () => <Image src="/app/assets/qa-chip.svg" alt="qa chip" height={18} width={26} />

export const OrganisationLogo: React.FC<OrganisationLogoProps> = ({ organisation, logoSize, sx }) => {
  const { name, logoUrl, isQa } = organisation

  if (typeof logoUrl === 'string') {
    return (
      <Stack direction="row" gap={1} alignItems="center" justifyContent="center" sx={sx}>
        <picture>
          <img
            src={logoUrl}
            alt={name}
            height={logoSize?.height ?? DEFAULT_HEIGHT}
            width={logoSize?.width}
            style={{ display: 'block', objectFit: 'contain' }}
          />
        </picture>
        {isQa && <QaChip />}
      </Stack>
    )
  }

  const height = !logoUrl || !logoSize?.height ? DEFAULT_HEIGHT_PX : logoSize.height
  const fontSize = logoUrl ? { fontSize: height } : {}

  return (
    <Stack
      direction="row"
      gap={1}
      alignItems="center"
      justifyContent="center"
      sx={[logoSize, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      <Typography color="text.default" variant="display-h3" sx={{ lineHeight: height, ...fontSize }}>
        {name}
      </Typography>
      {isQa && <QaChip />}
    </Stack>
  )
}
